import { bundleConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { BundleQueryResponseOut } from '../../../../store/api';

export const fetchRelatedBundles = (productId: string) => {
    const pathParams = {
        productId
    };
    return http
        .get<BundleQueryResponseOut>(bundleConfig().endpointRelatedBundles, {
            pathParams,
            errorCodesToSkip: [404]
        })
        .then(response => response.data);
};
